export default __webpack_public_path__ + "static/media/2.cff20bd0.png";